module.exports = __webpack_public_path__ + "img/altruvest-logo.e6eec2e0.png";